import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CompletionBehaviorTemplate } from "../../../../entities/completionBehaviorTemplate/completionBehaviorTemplate";
import { ToastService } from "../../../toast/toast.service";
import { CompletionBehavior, HasCommands, Reloadable } from "../command.service";

@Injectable({
    providedIn: 'root'
  })
export class ReloadCompletionBehavior implements CompletionBehavior {

    constructor(
        private toastService: ToastService,
        private router: Router
    ) { }

    executeCompletionBehavior(hasCommands: HasCommands, completionBehaviorTemplate: CompletionBehaviorTemplate, reloadable?: Reloadable) {

        const showToast = completionBehaviorTemplate?.settings?.showToast;
        const toastMessage = completionBehaviorTemplate?.settings?.toastMessage;
        console.log('====')
        if(reloadable){
            reloadable.reload();
        }

        if(showToast && toastMessage){
            this.toastService.addToastWithMessage(toastMessage);
        }

        console.log('reload')

    }

}